import { Headers } from '@egw/components'
import { FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { RedesignFoundationPage } from '@egw/features-foundation'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const PersonalFoundationPage: FC = () => {
  const { t } = useTranslation()

  const { flags } = useFlags<FeatureFlags>()

  return (
    <Layout>
      <Headers title={t('pages.personal-foundation.title')} />
      {<RedesignFoundationPage />}
    </Layout>
  )
}
